import { render, staticRenderFns } from "./Andoras.vue?vue&type=template&id=28888770&"
import script from "./Andoras.vue?vue&type=script&lang=js&"
export * from "./Andoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports